

































































import Vue from 'vue';
import store from '@/store';
import _ from 'lodash';
import Sticky from 'vue-sticky-directive';
import PropertySearch from './property-search.vue';
import PropertyMenu from './property-menu.vue';
import PropertyResults from './property-results.vue';
import PropertyUserFavourites from './property-user-favourites.vue';
import { Component, Prop, Watch } from "vue-property-decorator";
import FabFeedback from "@/components/common/fab-feedback.vue";
import AuthAuthenticator from "@/components/auth/auth-authenticator.vue";
import CustomAuthenticator from "@/components/auth/auth-custom-authenticator.vue";
import AppNav from "@/components/common/app-nav.vue";
import { getModule } from "vuex-module-decorators";
import UserAuth from "@/store/auth/UserAuth";
import DecisionModule from "@/store/decision/Decision";

@Component({
  components: {
    'property-user-favourites': PropertyUserFavourites,
    'property-search': PropertySearch,
    'property-menu': PropertyMenu,
    'property-results': PropertyResults,
  },
  directives: {Sticky}
})
export default class PropertyPage extends Vue {


  @Prop({type: String, default: () => 'Default Viewpoint'})
  viewpointName!: string;
  @Prop({type: String, default: () => 'Score'})
  factorGroupName!: string;
  @Prop({type: String, default: () => 'ok'})
  status!: string;


  private updatedFlag = 0
  private showFavourites = false
  private searchQuery = ''
  private dialog = false
  private drawer = false


  created() {
    console.log('[ PropertyPage created() ]');
    let name: any = this.$route.name;
    if (name === 'mls') {
      this.showFavourites = false;
    }
    if (name === 'favorites') {
      this.showFavourites = true;
    }
    let subSection: any = this.$route.params.subSection;
    if (subSection === 'mls') {
      this.showFavourites = false;
    }
    if (subSection === 'favorites') {
      this.showFavourites = true;
    }
  }

  mounted() {


  }

  @Watch('routeName')
  watchRouteName(newVal: string, oldVal: string) {
    if (newVal === 'mls') {
      this.showFavourites = false;
    }
    if (newVal === 'favorites') {
      this.showFavourites = true;
    }
  }

  @Watch('routeParam')
  watchRouteParam(newVal: string, oldVal: string) {
    if (newVal === 'mls') {
      this.showFavourites = false;
    }
    if (newVal === 'favourites') {
      this.showFavourites = true;
    }
  }


  get routeName(): any {
    return this.$route.name;
  }

  get routeParam(): any {
    return this.$route.params.subSection;
  }

  get factors() {
    return getModule(DecisionModule).factors
  }


  get isLoggedIn(): any {
    return getModule(UserAuth).user;
  }

  switchView(event: any) {
    this.showFavourites = event;
  }

  updateSearch(event: any) {
    console.log('[SEARCH UPDATED]: ' + event);
    this.searchQuery = event;
    this.updatedFlag++;
  }

  factorsUpdated() {
    this.updatedFlag++;
  }

  openFactors() {
    this.drawer = true;
  }


}

